

import { LatLng } from "../types/index";

/**
 * Calculates the great-circle distance between two points
 * using the haversine formula.
 * @returns Distance in kilometers.
 */
export function haversineDistance(
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number
): number {
  const toRad = (x: number) => (x * Math.PI) / 180;
  const R = 6371; // Earth radius in km

  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

/**
 * Builds a unique cache key for a pair of coordinates.
 */
export function getDistanceKey(
  origin: LatLng,
  destination: LatLng
): string {
  return `${origin.lat},${origin.lng}_${destination.lat},${destination.lng}`;
}